import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';
import { Box, styled } from '@mui/material';

const StyledTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  '& th, & td': {
    border: '1px solid #ddd',
    padding: '8px',
  },
  '& th': {
    paddingTop: '12px',
    paddingBottom: '12px',
    textAlign: 'left',
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
  },
}));

const CenteredH1 = styled('h1')({
  textAlign: 'center',
  fontSize: '2em',  // Adjust the size as needed
  margin: '1em 0',
});

const GaDocument = ({ content }) => {
  return (
    <Box>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw, rehypeSlug]}
        remarkPlugins={[remarkGfm]}
        components={{
          table: ({ node, ...props }) => <StyledTable {...props} />,
          h1: ({ node, ...props }) => <CenteredH1 {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};

export default GaDocument;
